import { render, staticRenderFns } from "./SearchSubmissions.vue?vue&type=template&id=e5a2fc44&scoped=true&"
import script from "./SearchSubmissions.vue?vue&type=script&lang=ts&"
export * from "./SearchSubmissions.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSubmissions.vue?vue&type=style&index=0&id=e5a2fc44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2fc44",
  null
  
)

export default component.exports